export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2-e07bf872f4b96145e28cc3e475244f6a.webp";